export default __webpack_public_path__ + "static/media/gInterior.4a3d7bae.PNG";